import React from "react";

const InputField = ({
  label,
  value,
  onChange,
  isEditing,
  customStyle,
  isDisabled,
  errorMessage,
}) => (
  <div className="input-field" style={customStyle}>
    <label>{label}</label>
    {isEditing ? (
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={isDisabled}
      />
    ) : (
      <div className="display-value">{value}</div>
    )}
    {errorMessage && <div className="error-message">{errorMessage}</div>}
  </div>
);

export default InputField;
